let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("dfxiP")).then(() => parcelRequire('hzBa5'));